import React from 'react';

const Cookies = () => (
  <div className="max-w-3xl mx-auto px-4 py-16 text-text-primary">
    <h1 className="text-3xl font-bold mb-6">Cookie Policy</h1>
    <p className="mb-4">AtlasMoth uses cookies and similar technologies to enhance your experience on our website.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">What Are Cookies?</h2>
    <p className="mb-4">Cookies are small text files stored on your device by your browser. They help us analyze site usage and personalize content.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">How We Use Cookies</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>To remember your preferences and settings.</li>
      <li>To analyze website traffic and improve our services.</li>
      <li>For newsletter signup and analytics integrations.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-8 mb-2">Managing Cookies</h2>
    <p className="mb-4">You can manage or disable cookies in your browser settings. Some site features may not work properly if cookies are disabled.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">Third-Party Cookies</h2>
    <p className="mb-4">We may use third-party services (such as analytics or newsletter tools) that set their own cookies. Please refer to their policies for more information.</p>
    <h2 className="text-xl font-semibold mt-8 mb-2">Contact</h2>
    <p>If you have questions about our cookie policy, email us at <a href="mailto:kbaid@atlasmoth.com" className="underline">kbaid@atlasmoth.com</a>.</p>
    <p className="mt-8 text-xs text-text-secondary">Last updated: June 15, 2025</p>
  </div>
);

export default Cookies;
